import styled from 'styled-components'
import GImage from 'components/common/gImage'
import { PaddingContainer, GridMixin } from 'components/common/common_styles'
import { sizeMedium } from 'components/globalStyles'
import { StyledP } from 'components/common/typography'

export const MainContainer = styled(PaddingContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MapContainer = styled(GImage)`
  margin: 100px 0;
  max-width: 65%;
`

export const LowerTextContainer = styled.div`
  ${GridMixin};
  grid-template-columns: 1fr 1fr;
  column-gap: 100px;
  margin: 0 100px;

  @media (max-width: ${sizeMedium}) {
    margin: 0;
  }
`

export const MobileTitleSelector = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 42px;
`

export const MobileTitle = styled(StyledP)`
  position: relative;
  color: ${props => (props.selected ? 'var(--spBlack)' : 'var(--gray1)')};
  font-weight: ${props => (props.selected ? '600' : 'normal')};
`

export const MobileUnderline = styled.img`
  position: absolute;
  bottom: 3px;
  width: 100%;
  height: 5px;
`
